<template>
<div class="chapter">
<div class="inner_page">
<div class="frontpage" id="frontpage">
<p class="paraNoIndentBB1"><em class="italic">This book is dedicated to the maintenance men who kept all the aircraft I flew whole through their non-stop labors. I trusted you with my life every day and your skill validated that trust. It is dedicated to the crewmen who flew with me and trusted me to bring them back as I trusted them to keep the helicopters ready, because after all, the aircraft was theirs, not mine. It is dedicated to the pilots who sat in the other seat while I flew and vice versa, each of us trusting the other’s skill and judgment. It is dedicated to the wives and families that watched us all go out in our fragile machines full of potential single-point failures. Watched us go and hoped for our return. Finally, it is dedicated to those who ran out of luck and superstition. We miss you.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_frontpage.vue?c4399156